import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PageServices from "../../services/PageServices";

function SrStock() {
  const [data, setData] = useState([]);
  const [support, setSupport] = useState(null);
  const [resistance, setResistance] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [date, setDate] = useState(""); // State for the selected date
const [activeTab, setActiveTab] = useState("support");
  const handleDateChange = (event) => {
    setDate(event.target.value);
  };

  console.log(date)
  useEffect(() => {
    if (date) { // Ensure date is not empty
      PageServices.getTripleSRStock(date)
        .then((response) => {
          console.log("API Response:", response?.data);
          setData(response?.data || []); // Ensure data is an array

          if (Array.isArray(response?.data)) {
            let supportData = null;
            let resistanceData = null;

            response.data.forEach((item) => {
              if (item?.resistanceSupport === "Support: Active") {
                supportData = item;
              } else if (item?.resistanceSupport === "Resistance: Active") {
                resistanceData = item;
              }
            });

            setSupport(supportData);
            setResistance(resistanceData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [date]); // 🔥 Added date as dependency


  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  // Updated groupByProduct: group by symbol + timestamp so we keep all entries
  const groupByProduct = (data) => {
    const groupedData = {};
    data.forEach((item) => {
      const product = item?.symbol || item?.options?.Request?.Product;
      const key = `${product}-${item.parentTimestamp}`; // ✅ unique by product + timestamp

      if (groupedData[key]) {
        groupedData[key].count += 1;
      } else {
        groupedData[key] = { ...item, count: 1 };
      }
    });
    return Object.values(groupedData);
  };

  // Show PE in Support
  const filteredSupportData = data.filter(
    (item) =>
      item?.optionType === "PE" &&
      item?.symbol?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Show CE in Resistance
  const filteredResistanceData = data.filter(
    (item) =>
      item?.optionType === "CE" &&
      item?.symbol?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Group before rendering
  const groupedSupportData = groupByProduct(filteredSupportData);
  const groupedResistanceData = groupByProduct(filteredResistanceData);

  console.log("groupedSupportData", groupedSupportData);
  console.log("groupedResistanceData", groupedResistanceData);

  // Get current date in YYYY-MM-DD format
  const currentDate = new Date().toISOString().split("T")[0];
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };
  const getFormattedTime24 = (timestamp) => {
    const date = new Date(new Date(timestamp).getTime() - 5.5 * 60 * 60 * 1000); // Adjust for IST
    return date.toTimeString().slice(0, 5); // Returns "HH:mm"
  };

  return (
    <section className="sr-stocks-section py-70">
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center mb-2 px-2 flex-wrap gap-2">
          <div className="col-auto">
            <Link to="/trend-with-stocks" className="btn btn-outline-secondary btn-sm">
              Bullish / Bearish with Trend →
            </Link>
          </div>
          <div className="col-auto">
            <input
              className="form-control"
              type="date"
              id="dateInput"
              value={date || currentDate}
              onChange={handleDateChange}
              style={{ width: "100%", minWidth: "160px" }}
            />
          </div>
        </div>

        {/* Tabs */}
        <ul className="nav nav-pills mb-3 justify-content-center">
          <li className="nav-item">
            <button
              className={`nav-link site-btn ${activeTab === "support" ? "active" : ""}`}
              style={{
                backgroundColor: activeTab === "support" ? "green" : "",
                color: activeTab === "support" ? "white" : ""
              }}
              onClick={() => setActiveTab("support")}
            >
              Support
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link site-btn ${activeTab === "resistance" ? "active" : ""}`}
              style={{
                backgroundColor: activeTab === "resistance" ? "red" : "",
                color: activeTab === "resistance" ? "white" : ""
              }}
              onClick={() => setActiveTab("resistance")}
            >
              Resistance
            </button>
          </li>
        </ul>

        {/* Tab Content */}
        <div className="tab-content">
          {/* Support Tab */}
          <div className="tab-pane fade show active" id="pills-support">
            {groupedSupportData.length > 0 ? (
              <>
                {/* Search */}
                <div className="searchForm text-center mb-3">
                  <div className="d-inline-flex align-items-center border rounded px-2 bg-white">
                    <i className="fa fa-search" />
                    <input
                      type="text"
                      placeholder="Search for..."
                      value={searchQuery}
                      onChange={handleSearchChange}
                      className="border-0 outline-0 ms-2"
                      style={{ fontSize: "16px", width: "200px" }}
                    />
                  </div>
                </div>

                {/* Data */}
                <div className="trends-stocks stocks-outer">
                  <div className="trends-stocks-inner sr-stocks-inner">
                    {groupedSupportData.map((stock, index) => (
                      <button key={index} className="stocks-box">
                        <h6 style={{color:'#fff'}}>
                          {stock.symbol}{" "}
                          <span className="bg-primary text-white px-2 rounded">
                            {stock.count > 0 ? stock.count : ""}
                          </span>
                        </h6>
                        <h5 className="time" style={{color:'#fff'}}>
                          {new Date(new Date(stock.parentTimestamp).getTime() - 5.5 * 60 * 60 * 1000).toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </h5>
                        <div className="flex justify-center mt-4 space-x-2">
                          <button
                            className="px-4 py-1 border border-blue-500 text-blue-500 rounded-md hover:bg-blue-50"
                            onClick={() => {
                              const dateStr = formatDate(stock.timestamp);
                              const timeStr = getFormattedTime24(stock.timestamp);
                              const symbolToken = stock?.options?.Request?.Product;
                              localStorage.setItem("stock", symbolToken);
                              window.open(`/backtester?date=${dateStr}&time=${timeStr}&symbolToken=${symbolToken}`, "_blank");
                            }}
                          >
                            Historical
                          </button>
                          <button
                            className="px-4 py-1 border border-blue-500 text-blue-500 rounded-md hover:bg-blue-50"
                            onClick={() => {
                              localStorage.setItem("stock", stock?.options?.Request?.Product);
                              window.open("/optionchain", "_blank");
                            }}
                          >
                            Live Data
                          </button>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <p className="text-center">No active support data available.</p>
            )}
          </div>

          {/* Resistance Tab */}
          <div className="tab-pane fade" id="pills-resistance">
            {groupedResistanceData.length > 0 ? (
              <>
                {/* Search */}
                <div className="searchForm text-center mb-3">
                  <div className="d-inline-flex align-items-center border rounded px-2 bg-white">
                    <i className="fa fa-search" />
                    <input
                      type="text"
                      placeholder="Search for..."
                      value={searchQuery}
                      onChange={handleSearchChange}
                      className="border-0 outline-0 ms-2"
                      style={{ fontSize: "16px", width: "200px" }}
                    />
                  </div>
                </div>

                {/* Data */}
                <div className="trends-stocks stocks-outer">
                  <div className="trends-stocks-inner sr-stocks-inner">
                    {groupedResistanceData.map((stock, index) => (
                      <button key={index} className="stocks-box">
                        <h6 style={{color:'#fff'}}>
                          {stock?.symbol}{" "}
                          <span className="bg-primary text-white px-2 rounded">
                            {stock.count > 0 ? stock.count : ""}
                          </span>
                        </h6>
                        <h5 className="time"style={{color:'#fff'}}>
                          {new Date(new Date(stock.parentTimestamp).getTime() - 5.5 * 60 * 60 * 1000).toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </h5>
                        <div className="flex justify-center mt-4 space-x-2">
                          <button
                            className="px-4 py-1 border border-blue-500 text-blue-500 rounded-md hover:bg-blue-50"
                            onClick={() => {
                              const dateStr = formatDate(stock.timestamp);
                              const timeStr = getFormattedTime24(stock.timestamp);
                              const symbolToken = stock?.options?.Request?.Product;
                              localStorage.setItem("stock", symbolToken);
                              window.open(`/backtester?date=${dateStr}&time=${timeStr}&symbolToken=${symbolToken}`, "_blank");
                            }}
                          >
                            Historical
                          </button>
                          <button
                            className="px-4 py-1 border border-blue-500 text-blue-500 rounded-md hover:bg-blue-50"
                            onClick={() => {
                              localStorage.setItem("stock", stock?.options?.Request?.Product);
                              window.open("/optionchain", "_blank");
                            }}
                          >
                            Live Data
                          </button>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <p className="text-center">No active resistance data available.</p>
            )}
          </div>
        </div>
      </div>
    </section>

  );
}

export default SrStock;
